var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('Requerimiento',{attrs:{"area":_vm.area},on:{"update":_vm.obtener_etapas}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mt-3 mb-3"},[_c('h1',{staticClass:"col-sm-12 text-right"},[_vm._v("Requerimientos")])])
}]

export { render, staticRenderFns }